import { createAction } from 'redux-act';

import * as payments from '../../core/payments';

export const fetchPaymentDetails = createAction(
  'get all payment details',
);
export const fetchPaymentDetailsSuccess = createAction(
  'get all payment details success',
  (payment) => payment
);
export const fetchPaymentDetailsFail = createAction(
  'get all payment details fail',
  (error) => error
);

export const fetchPaymentsTotalBalance = createAction(
  'get all payments total balance',
);
export const fetchPaymentsTotalBalanceSuccess = createAction(
  'get all payments total balance success'
);

export const fetchPaymentsTotalBalanceFail = createAction(
  'get all payments total balance fail',
  (error) => error
);

export const setPaymentPaid = createAction(
  'set payment as paid',
);

export const setPaymentPaidSuccess = createAction(
  'set payment as paid success'
);

export const setPaymentPaidFail = createAction(
  'set payment as paid fail',
  (error) => error
);

export const refreshBalance = createAction(
  'refresh payment balance',
);

export const refreshBalanceSuccess = createAction(
  'refresh payment balance success',
);

export const refreshBalanceFail = createAction(
  'refresh payment balance fail',
);

export const showRefreshBalance = createAction(
  'show refresh balance modal'
);

export const hideRefreshBalance = createAction(
  'hide refresh balance modal'
);

export const getPeriods = createAction(
  'get payment periods'
);

export const getPeriodsSuccess = createAction(
  'get payment periods success'
);
export const getPeriodsFail = createAction(
  'get payment periods fail'
);

export const getLastRefreshDate = createAction(
  'get last refresh date'
);

export const getLastRefreshDateSuccess = createAction(
  'get last refresh date success'
);
export const getLastRefreshDateFail = createAction(
  'get last refresh date fail'
);

export const getNextPaymentCycle = createAction(
  'get next payment cycle'
);
export const getNextPaymentCycleSuccess = createAction(
  'get next payment cycle success'
);
export const getNextPaymentCycleFail = createAction(
  'get next payment cycle fail'
);

export const processPayments = createAction(
  'process payments'
);
export const processPaymentsSuccess = createAction(
  'process payments success'
);
export const processPaymentsFail = createAction(
  'process payments fail'
);

export const reducer = {
  [fetchPaymentDetails]: (state, payload) =>
    payments.fetchPaymentDetails(state, payload),
  [fetchPaymentDetailsSuccess]: (state, payload) =>
    payments.fetchPaymentDetailsSuccess(state, payload),
  [fetchPaymentDetailsFail]: (state, payload) =>
    payments.fetchPaymentDetailsFail(state, payload),
  [fetchPaymentsTotalBalanceSuccess]: (state, payload) =>
    payments.fetchPaymentsTotalBalanceSuccess(state, payload),
  [setPaymentPaidSuccess]: (state, payload) =>
    payments.updatePaymentSuccess(state, payload),
  [refreshBalance]: (state, payload) =>
    payments.refreshBalance(state, payload),
  [refreshBalanceSuccess]: (state, payload) =>
    payments.setRefreshDate(state, payload),
  [refreshBalanceFail]: (state, payload) =>
    payments.refreshBalanceFail(state, payload),
  [showRefreshBalance]: (state, payload) =>
    payments.showRefreshBalance(state, payload),
  [hideRefreshBalance]: (state) =>
    payments.hideRefreshBalance(state),
  [getPeriodsSuccess]: (state, payload) =>
    payments.getPeriodsSuccess(state, payload),
  [getLastRefreshDateSuccess]: (state, payload) =>
    payments.setRefreshDate(state, payload),
  [getNextPaymentCycleSuccess]: (state, payload) =>
    payments.setNextPaymentCycle(state, payload),
  [processPayments]: (state, payload) =>
    payments.processPayments(state, payload),
  [processPaymentsSuccess]: (state, payload) =>
    payments.processPaymentsSuccess(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/payments.module.js
 **/